import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import DeleteIcon from "@mui/icons-material/Delete";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  borderRadius: 2,
  boxShadow: 24,
  p: 4,
};

const theme = createTheme({
  palette: {
    neutral: {
      main: "#039255",
      contrastText: "#fff",
    },
    neutralsize: {
      width: "10px",
    },
  },
});

const ChapterListModaldelete = ({render,setRender,item}) => {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleDeleteChapter = async () => {
    // if (!checkboxObj) {
    //   toast.warning("please choose channel for the user");
    //   return;
    // }
    // if (!values.name) {
    //   toast.warning("please enter  name");
    //   return;
    // }
    // if (!values.phone) {
    //   toast.warning("please enter  phone");
    //   return;
    // }
    // if (!values.email) {
    //   toast.warning("please enter  email");
    //   return;
    // }
    // if (!values.password) {
    //   toast.warning("please enter  password");
    //   return;
    // }
    // let formdata = new FormData();
    // formdata.append("name", name);
    // formdata.append("category",category);
    // formdata.append("description",description);
    // formdata.append("image",image);
    // console.log(formdata);

    try {
      const res = await axios.delete(
        `api/v1/a34jl49u-q4r67p89/courses/03160837-4207-4a47-b45f-2be62a2c99e9/chapter/${item._id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            withCredentials: true,
            // Authorization: token,
          },
        }
      );
      console.log(res);
      if (res.status === 200 || res.statusText === "OK") {
        toast.success("success");
        setRender(!render);
        handleClose();
        return;
      }
    } catch (err) {
      // toast.error(err);
      console.log(err.response.data.message);
      // toast.error(err.response.data.message);
    }
  };

  return (
    <div>
      <ThemeProvider theme={theme}>
        <Button sx={{ minWidth: "10px" }} onClick={handleOpen}>
          <DeleteIcon sx={{ color: "#686868" }} />
        </Button>
      </ThemeProvider>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Box sx={{ textAlign: "center" }}>
            <HighlightOffIcon
              sx={{ fontSize: 50, color: "red", marginBottom: 1 }}
            />
          </Box>
          <Typography
            sx={{ textAlign: "center" }}
            id="modal-modal-title"
            variant="h6"
            component="h2"
          >
            Are you sure?
          </Typography>
          <Typography
            id="modal-modal-description"
            sx={{ mt: 2, textAlign: "center" }}
          >
            Do you really want to delete these chapter? This process cannot be
            undone.
          </Typography>
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <Button
              onClick={handleClose}
              sx={{
                marginTop: 3,
                boxShadow: "none !important",
                marginRight: 2,
              }}
              variant="contained"
            >
              Cancel
            </Button>
            <Button
              onClick={handleDeleteChapter}
              sx={{ marginTop: 3, boxShadow: "none !important" }}
              variant="contained"
              color="error"
            >
              Delete
            </Button>
          </Box>
        </Box>
      </Modal>
    </div>
  );
};

export default ChapterListModaldelete;
